import React from "react";

const DimensionsCellRenderer = (props) => {
    const { value } = props;

    return (
        <div className="double-renderer-outer">
          <div className="double-renderer-field">
              Lung: {value?.length} m
          </div>
          <div className="double-renderer-field">
              Altezza: {value?.height} m
          </div>
        </div>
    );
};

export default DimensionsCellRenderer;
